import React, { useState } from "react";
// Store Utils
import { useDispatch } from "react-redux";
import { observationsStatusAction } from "store/filters/reducer.actions";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { sentenceCase } from "change-case";
import { filtersInitialState } from "store/filters/initialState";

interface TabsProps {
  onChange?: (tab: string) => void;
}

export const FileTab: React.FC<TabsProps> = ({ onChange }) => {
  const [selectedTab, setSelectedTab] = useState("add_file");

  const dispatch = useDispatch();
  const tabsData = [
    {
      title: "Add File",
      value: "add_file",
    },
    {
      title: "Add URL",
      value: "add_url",
    },
  ];
  //handlers
   const handleLink = (linkName: string) => {
    setSelectedTab(linkName);
    onChange?.(linkName); 
  };

  return (
    <>
      <div className="flex mb-5">
        {tabsData.map((item: any, index: number) => {
          const isActive = selectedTab === item.value;
          return (
            <div
              key={index}
              className={`group flex cursor-pointer justify-center items-center flex-grow-0 flex-shrink-0 px-4 py-3 ${isActive
                ? "border-b-2 border-primaryMid "
                : "border-lineMid border-b-2  hover:border-lineDarkExtra"
                }`}
              onClick={() => handleLink(item.value)}
            >
              <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 relative px-1.5 pt-1.5 pb-2 ">
                <p
                  className={`flex-grow-0 flex-shrink-0 text-sm font-semibold text-center uppercase text-secondary group-hover:dark:text-textMain ${
                    isActive
                      ? " dark:text-textMain "
                      : "dark:text-caption opacity-50"
                  }`}
                >
                  {sentenceCase(item.title)}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
